// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"d29406fb","305":"6414dce7"}[chunkId] + ".chunk.css";
};